import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { Config } from '../config';

@Injectable({ providedIn: 'root' })
export class AddHeaderInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    const session =  JSON.parse(localStorage.getItem('okta-token-storage') || "{}");
    let token = session!.idToken?.idToken || "";

    const apiUrl = Config.projectApiUrl ?? "Default Api Url";
    const appUrl = window.location.href;

    if (apiUrl === "Default Api Url" || (!req.url.includes(apiUrl) && !appUrl.includes("localhost:"))) {
      token = "";
    }

    let jsonReq: HttpRequest<any>;

    let headers = {};
    headers = !req.url.includes('S3File') ?
    { 'Content-Type': 'application/json', identity: Config.user.name, Authorization: `Bearer ${token}` } :
    { identity: Config.user.name, Authorization: `Bearer ${token}` }

   // if (req.url.includes(apiUrl)) {
      jsonReq = req.clone({
        setHeaders: { ...headers }
      });
   // } else {
   //   jsonReq = req.clone();
   // }

    return next.handle(jsonReq);

    
  }
}
